import MultiVue from 'vue-multivue';
import McsBaseComponent from './components/McsBaseComponent.vue';

new MultiVue('.mcs-app', {
  components: {
    McsBaseComponent
  }
});